import pollTask from './pollTask';

export default async (taskId, { onSuccess, onError } = {}) => {
  try {
    const { result, task } = await pollTask(taskId);

    if (onSuccess && typeof onSuccess === 'function') {
      await onSuccess(result, task);
    }

    return Promise.resolve({ result, task });
  } catch (err) {
    if (onError && typeof onError === 'function') {
      onError(err);
    }

    return Promise.reject(err);
  }
};
